import { UserRole, isAdmin, isMedicalExpertRole } from "@/domain/entity/auth/user-session-entity";
import { PatientListFilter, PatientSummary } from "@/domain/entity/patient/patient-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientListUsecase {
  constructor(private readonly patientRepo: PatientRepository) {}

  async execute(filter?: PatientListFilter): Promise<SATResult<PatientSummary[], SATError>> {
    return this.patientRepo.fetchPatients(filter);
  }

  async executeByRole(
    role: UserRole,
    filter?: PatientListFilter,
  ): Promise<SATResult<PatientSummary[], SATError>> {
    if (isAdmin(role)) return this.executeForAdmin(filter);
    if (isMedicalExpertRole(role)) return this.executeForDoctor(filter);
    return this.patientRepo.fetchPatients(filter);
  }

  async executeForDoctor(filter?: PatientListFilter): Promise<SATResult<PatientSummary[], SATError>> {
    return this.patientRepo.fetchPatientsByDoctor(filter);
  }

  async executeForAdmin(filter?: PatientListFilter): Promise<SATResult<PatientSummary[], SATError>> {
    return this.patientRepo.fetchPatientsByAdmin(filter);
  }
}
